import SegmentedTabs from '../SegmentedTabs/SegmentedTabs';
import Button from '../Button/Button';
import FilterDropdown from '../FilterDropdown/FilterDropdown';
import { t } from '../../i18n/i18n';

const icon = (name) => ({ '--icon': `url(/icons/${name}.svg)` });

export default function TableToolbar({
  title,
  count,
  icon: iconName = 'table-rows',
  tabs,
  search,
  onSearchChange,
  searchPlaceholder,
  onFilters,
  onExport,
  actions,
  filter,
  filters,
}) {
  const showSearch = Boolean(searchPlaceholder);
  const filterList = filters ?? (Array.isArray(filter) ? filter : filter ? [filter] : null);

  return (
    <div className="table-toolbar">
      <div className="table-toolbar__title">
        <span className="icon table-toolbar__icon" style={icon(iconName)} />
        <span>
          {t(title)}
          {count != null && ` (${count})`}
        </span>
      </div>

      <div className="table-toolbar__actions">
        {tabs && (
          <SegmentedTabs options={tabs.options} value={tabs.value} onChange={tabs.onChange} />
        )}

        {showSearch && (
          <label className="table-toolbar__search">
            <span className="icon" style={icon('table-search')} />
            <input
              type="search"
              value={search}
              placeholder={t(searchPlaceholder)}
              onChange={(e) => onSearchChange(e.target.value)}
              aria-label={t(searchPlaceholder)}
            />
          </label>
        )}

        {filterList && filterList.length > 0 ? (
          filterList.map((f, i) => (
            <FilterDropdown
              key={f.key || f.label || i}
              options={f.options}
              value={f.value}
              onChange={f.onChange}
              label={f.label || 'Filters'}
            />
          ))
        ) : onFilters ? (
          <Button
            variant="toolbar"
            iconPlacement="end"
            icon={<span className="icon" style={icon('user-updown')} />}
            onClick={onFilters}
          >
            {t('Filters')}
          </Button>
        ) : null}

        {onExport && (
          <Button
            variant="toolbar"
            iconPlacement="end"
            icon={<span className="icon" style={icon('export')} />}
            onClick={onExport}
          >
            {t('Export')}
          </Button>
        )}

        {actions}
      </div>
    </div>
  );
}
